import React, { PropsWithChildren } from 'react'
import { Toast, ToastContainer, ToastContainerProps, ToastProps } from 'react-bootstrap'
import './SummaryToast.scss'
import styles from '../../../../../components/Button/Button.module.scss'

export type SummaryToastVariant = 'success' | 'warning' | 'error' | string

export interface SummaryToastProps {
  show: boolean
  onClose: () => void
  variant?: SummaryToastVariant
  toastContainerClassName?: string
  toastClassName?: string
  toastContainerProps?: ToastContainerProps
  toastProps?: ToastProps
}

export const SummaryToast: React.FC<PropsWithChildren<SummaryToastProps>> = ({
  show,
  onClose,
  variant,
  toastContainerClassName,
  toastClassName,
  toastContainerProps,
  toastProps,
  children,
}) => {
  const variantClassMap: { [key: string]: string } = {
    success: 'summary-toast-success',
    warning: 'summary-toast-warning',
    error: 'summary-toast-error',
  }

  const variantClass = variant ? variantClassMap[variant] : ''

  return (
    <ToastContainer
      position='bottom-center'
      className={`p-3 position-fixed summary-toast-container ${variantClass} ${toastContainerClassName}`}
      {...toastContainerProps}
    >
      <Toast onClose={onClose} show={show} delay={1500} autohide {...toastProps}>
        <Toast.Body className={`d-flex gap-2 toast-body ${toastClassName}`}>{children}</Toast.Body>
      </Toast>
    </ToastContainer>
  )
}
